import { CATEGORY_EMOJI } from "@/lib/reportVaultConstants";

// Pill-button filter row ("All Reports" + one pill per AI-detected category
// present in this patient's vault) for the Report Vault tab.
export function ReportCategoryFilters({ presentCategories, categoryFilter, setCategoryFilter }) {
  if (presentCategories.length === 0) return null;
  return (
    <div className="mt-4 flex flex-wrap gap-2" data-testid="report-category-filters">
      <button
        data-testid="category-filter-All"
        onClick={() => setCategoryFilter("All")}
        className={`rounded-full px-3 py-1 text-xs font-medium border transition-colors ${categoryFilter === "All" ? "bg-teal-700 text-white border-teal-700" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}
      >
        All Reports
      </button>
      {presentCategories.map((cat) => (
        <button
          key={cat}
          data-testid={`category-filter-${cat.replace(/\s/g, "-")}`}
          onClick={() => setCategoryFilter(cat)}
          className={`rounded-full px-3 py-1 text-xs font-medium border transition-colors ${categoryFilter === cat ? "bg-teal-700 text-white border-teal-700" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}
        >
          {CATEGORY_EMOJI[cat]} {cat}
        </button>
      ))}
    </div>
  );
}
